import React, { type FC, type ReactNode } from 'react';
import { Navigate } from 'react-router';

import { ISPARTYAGENT } from '../constants/global';
import { pageurl } from '../constants/pageurl';

// Nested inside AdminRoute, so the user is already logged in; this only checks the role.
const PartyAgentRoute: FC<{ children: ReactNode }> = ({ children }) => {
	if (!ISPARTYAGENT()) {
		return (
			<Navigate
				to={pageurl.OVERVIEW}
				replace
			/>
		);
	}
	return <>{children}</>;
};

export default PartyAgentRoute;
